import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Modal, Form, Button } from 'react-bootstrap'

import { IMaskInput } from "react-imask"

import axios from 'axios'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      name: ``,
      phone: ``,
      show_msg: false,
      modal_body: ``,
      sending: false
    }
  }

  changeName( name ) {
    this.setState({
      name: name
    })
  }
  changePhone( phone ) {
    this.setState({
      phone: phone
    })
  }

  handleShow_msg( text ) {
    this.setState({
      show_msg: true,
      modal_body: text
    })
  }
  handleClose_msg() {
    this.setState({
      show_msg: false
    })
  }

  sendForm = ( e ) => {
    const { title, data } = this.props,
    { name, phone, sending } = this.state

    e.preventDefault()

    if(sending) return

    const main = this,
    baseURL = window.location.protocol + "//" + window.location.hostname
    main.setState({ sending: true })
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'feedback_form',
      'form': title,
      'name': name,
      'phone': phone,
      'json': JSON.stringify( data )
    }).then( ( response ) => {
      if( response.data.result ) {
        main.props.handleClose()
        main.handleShow_msg( `Сообщение отправлено, наш менеджер свяжется с вами в ближайшее время.` )
      }
    }).catch( () => {
      main.handleShow_msg( `Ошибка отправки, попробуйте еще раз` )
    }).finally( () => {
      main.setState({ sending: false })
    })
  }

  render() {

    const { title, text, btn, show, handleClose } = this.props,
    { show_msg, modal_body, sending } = this.state

    return (
      <>
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {text &&
              <p>{text}</p>
            }
            <Form onSubmit={( e ) => this.sendForm( e )}>
              <Form.Group className="mb-3">
                <Form.Control required disabled={sending} onChange={( e ) => this.changeName( e.target.value )} type="text" placeholder="Ваше имя" />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control required disabled={sending} onChange={( e ) => this.changePhone( e.target.value )} as={IMaskInput} mask="+{7} (000) 000-00-00" lazy={true} type="phone" placeholder="Ваш телефон" />
              </Form.Group>
              <Button type="submit" size="lg" className='w-100' variant="dark" disabled={sending}>{sending ? `Идет отправка...` : ( btn != `` ? btn : `Отправить` )}</Button>
            </Form>
          </Modal.Body>
        </Modal>
        <Modal centered show={show_msg} onHide={() => this.handleClose_msg()}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='text-center'>{modal_body}</div>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

Main.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  btn: PropTypes.string,
  data: PropTypes.array,
  show: PropTypes.bool,
  handleClose: PropTypes.func
}